(() => {
 const fc=document.getElementById('fc');
 const evidence=document.querySelector('#press-feature .tvlab');
 let previousShown,frame=0;
 const onScroll=()=>{
   frame=0;
   const shown=evidence.getBoundingClientRect().top<innerHeight;
   if(shown===previousShown)return;
   previousShown=shown;
   fc.classList.toggle('on',shown);
   fc.inert=!shown;
   fc.setAttribute('aria-hidden',String(!shown));
 };
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(onScroll)};
 addEventListener('scroll',schedule,{passive:true});
 addEventListener('resize',schedule,{passive:true});
 new ResizeObserver(schedule).observe(document.getElementById('article'));
 onScroll();
 const canonical=location.href;
 const url=encodeURIComponent(canonical),title=encodeURIComponent(document.title);
 document.querySelectorAll('.share-row a,.share-row button').forEach(e=>{e.setAttribute('aria-disabled','true');e.tabIndex=-1;e.style.pointerEvents='none';});
 document.getElementById('shX').href='https://twitter.com/intent/tweet?text='+title+'&url='+url;
 document.getElementById('shLine').href='https://social-plugins.line.me/lineit/share?url='+url;
 document.getElementById('shCopy').addEventListener('click',async()=>{
   const done=document.getElementById('shDone');
   try{await navigator.clipboard.writeText(canonical);done.textContent='已複製連結';}
   catch{done.textContent='無法複製連結';}
   done.style.display='inline';setTimeout(()=>done.style.display='none',1800);
 });
 document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',event=>{
   const target=document.getElementById(a.hash.slice(1));if(!target)return;
   event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
 }));

 const viewer=document.getElementById('press-viewer');
 const paperScroll=viewer.querySelector('.viewer-scroll');
 const fitButton=viewer.querySelector('.viewer-fit');
 let returnFocus=null,returnX=0,returnY=0;
 const setZoom=zoomed=>{
   viewer.classList.toggle('is-zoomed',zoomed);
   fitButton.textContent=zoomed?'顯示全圖':'放大文字';
   paperScroll.scrollTo(0,0);
 };
 const openViewer=(trigger,pushHistory=true)=>{
   if(viewer.open)return;
   returnFocus=trigger||returnFocus||document.querySelector('.press-zoom');
   const savedPosition=!pushHistory&&history.state?.wandryPressReturn;
   returnX=savedPosition?.x??scrollX;returnY=savedPosition?.y??scrollY;
   if(pushHistory)history.pushState({...history.state,wandryPressImage:true,wandryPressReturn:{x:returnX,y:returnY}},'','#newspaper-image');
   document.documentElement.classList.add('image-viewer-open');
   viewer.showModal();
   viewer.querySelector('img').loading='eager';
   setZoom(true);
 };
 const dismissViewer=()=>{
   if(!viewer.open)return;
   viewer.close();
   if(history.state?.wandryPressImage)history.back();
 };
 document.querySelectorAll('[data-press-open]').forEach(trigger=>trigger.addEventListener('click',event=>{
   event.preventDefault();openViewer(trigger);
 }));
 viewer.querySelector('.viewer-close').addEventListener('click',dismissViewer);
 fitButton.addEventListener('click',()=>setZoom(!viewer.classList.contains('is-zoomed')));
 viewer.addEventListener('cancel',event=>{event.preventDefault();dismissViewer();});
 viewer.addEventListener('keydown',event=>{
   if(event.key!=='Tab')return;
   if(event.shiftKey&&document.activeElement===fitButton){event.preventDefault();paperScroll.focus();}
   else if(!event.shiftKey&&document.activeElement===paperScroll){event.preventDefault();fitButton.focus();}
 });
 viewer.addEventListener('click',event=>{if(event.target===viewer)dismissViewer();});
 viewer.addEventListener('close',()=>{
   document.documentElement.classList.remove('image-viewer-open');
   returnFocus?.focus({preventScroll:true});
   scrollTo({left:returnX,top:returnY,behavior:'instant'});
 });
 addEventListener('popstate',()=>{
   if(history.state?.wandryPressImage){openViewer(returnFocus,false);}
   else if(viewer.open){viewer.close();}
 });
 if(history.state?.wandryPressImage&&location.hash==='#newspaper-image')openViewer(null,false);
})();

// Carry attribution from the article to the selected product variant.
(()=>{const source=new URL(location.href);for(const a of document.querySelectorAll('a[href]')){const target=new URL(a.href,location.href);if(target.origin!==source.origin||!target.pathname.startsWith('/zh-tw/products/'))continue;for(const [key,value] of source.searchParams){if(key.startsWith('utm_')||['fbclid','gclid','ttclid','ad_id','adset_id','campaign_id'].includes(key))target.searchParams.set(key,value);}a.href=target.href;}})();

// Warm the next few article images before they reach the screen.
// Keep native lazy loading as the no-JS fallback and protect the hero first.
(()=>{
 if(!('IntersectionObserver' in window))return;
 const start=()=>{
   const observer=new IntersectionObserver(entries=>{
     for(const {target,isIntersecting} of entries){
       if(!isIntersecting)continue;
       target.loading='eager';
       target.decoding='async';
       observer.unobserve(target);
     }
   },{rootMargin:'3200px 0px'});
   document.querySelectorAll('#article img[loading="lazy"]').forEach(img=>observer.observe(img));
 };
 const hero=document.querySelector('.hero img');
 if(!hero||hero.complete)start();
 else{hero.addEventListener('load',start,{once:true});hero.addEventListener('error',start,{once:true});}
})();
